<script>
    import button from './ib-button.vue'
    import proxy from '../private/proxy';

    /**
     * This is a derivative of [ib-button](#/components/button/ib-button) that is floating outside the document flow,
     * and is anchored to a window corner. Like other overlay components, FAB buttons are rendered out of place.
     * They will automatically dodge bars, drawers, and other FAB buttons.
     */
    export default {
        name: 'ib-button-fab',
        mixins: [button],

        props: {
            /**
             * Dock position relative to window.
             */
            position: {
                type: String,
                default: 'bottom-end'
            }
        },

        data() {
            return {
                key: 0
            }
        },

        computed: {
            _class() {
                const tone = this.tone;
                const appearance = this.appearance;
                return {
                    [tone]: tone,
                    [appearance]: appearance,
                    '_btn-fab': true
                };
            }
        },

        beforeCreate() {
            let parent = this.$parent;
            while (parent) {
                if (parent.hostScope_) {
                    const dock = parent.dock;
                    const position = 'bottom-end';
                    if (!dock[position]) {
                        Vue.set(dock, position, []);
                    }
                    dock[position].push(this.entry = {
                        is: proxy,
                        key: 'dsajfsdaf',
                        attrs: {
                            hosted: this
                        }
                    });
                    this.host = parent;
                    this.render = this.$options.render;
                    this.$options.render = () => {};
                    return;
                }
                parent = parent.$parent;
            }
            throw new Error('no hosting scope');
        },

        beforeDestroy() {
            const host = this.host;
            const dock = host.dock;
            const position = 'bottom-end';
            if (dock[position]) {
                const index = dock[position].indexOf(this.entry);
                if (index >= 0) {
                    dock[position].splice(index, 1);
                }
            }
        },

        updated() {
            // referenced by proxy render function to propagate reactivity
            this.key++;
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btn {
        &-fab {
            visibility: visible;
            width: 2.5em;
            height: 2.5em;
            max-width: none;
            margin: 16px;
            padding: 0;
            border-radius: 50%;
            line-height: 0;
        }
    }
</style>

<ib-example id="icon" name="Icon">
    <template lang="pug">
        include ../../icon/map
        ib-button-fab(class="fs3")
            +icon-map-center_direction
    </template>
</ib-example>
